export default "__VITE_ASSET__27cb9105__"